import { Layout } from 'antd';
import { useContext, useEffect, useRef } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';

import { RoutesConstants } from '../../constants/routes-constants';
import { AuthContext } from '../../context/auth-context';
import { UserRoles } from '../../types/enum/user-roles';
import { HasRoles } from '../../utils/has-roles';
import HeaderLogo from './header/header-logo.component';
import Sidebar from './sidebar/sidebar.component';

export function AppLayout() {
  const { intendedDestination, setIntendedDestination, user } =
    useContext(AuthContext);
  const navigate = useNavigate();
  const defaultPath = useRef(
    HasRoles([UserRoles.LECTURER], user)
      ? '/events'
      : HasRoles([UserRoles.STAFF], user)
      ? '/work-logs-requests'
      : '/check-in'
  );

  useEffect(() => {
    if (!intendedDestination) {
      return;
    }

    setIntendedDestination(undefined);
    navigate(intendedDestination);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [intendedDestination, navigate]);

  return (
    <Layout>
      <HeaderLogo />
      {HasRoles([UserRoles.LECTURER, UserRoles.STAFF], user) ? (
        <Sidebar />
      ) : (
        <></>
      )}
      <div className='container py-5 px-2'>
        <Routes>
          {RoutesConstants(user).map((route, index) => {
            if (route.visibleToUser) {
              if (route.subroutes) {
                return (
                  <Route key={index} path={route.path} element={route.element}>
                    {route.subroutes.map((subroute, i) => {
                      if (subroute.visibleToUser) {
                        return (
                          <Route
                            key={i}
                            path={subroute.path}
                            element={subroute.element}
                          />
                        );
                      } else {
                        return undefined;
                      }
                    })}
                  </Route>
                );
              } else {
                return (
                  <Route
                    key={index}
                    path={route.path}
                    element={route.element}
                  />
                );
              }
            } else {
              return undefined;
            }
          })}
          <Route
            key='*'
            path='*'
            element={<Navigate to={defaultPath.current} />}
          />
        </Routes>
      </div>
    </Layout>
  );
}
